import Vue from 'vue';

export default {
    getAllByType({ arkona, type }) {
        const base = 'https://api.chapmanchoice.com';
        const path = `${base}/inventory/${type}/search/${arkona}`;
        return Vue.axios.get(path);
    },
    getDetail({ type, arkona, stockNumber }) {
        const base = 'https://api.chapmanchoice.com';
        const path = `${base}/inventory/${type}/detail/${arkona}/stock/${stockNumber}`;
        return Vue.axios.get(path);
    },
    getVehicleFees({ type, arkona }) {
        const path = `purchase/fees/${arkona}/${type}`;
        return Vue.axios(path);
    },
    getVehicleTaxes({ arkona }) {
        const path = `vehicles/taxes/${arkona}`;
        return Vue.axios(path);
    },
};
